import PropTypes from 'prop-types'
import React from 'react'
import Icon from 'components/common/icon'
import ICONS, { ICON_SIZE } from 'components/common/icon/const'
import { withI18next } from 'lib/i18n/withI18next'
import styles from './average-stars.scss'

const STARS_LIST = [1, 2, 3, 4, 5]

export const getStarIcon = (currentRating, averageRating) => {
  const previousRating = currentRating - 1
  const isHalfStar =
    averageRating > previousRating && currentRating > averageRating
  const isFullStar = averageRating >= currentRating

  if (isHalfStar) {
    return ICONS.starHalf
  }

  if (isFullStar) {
    return ICONS.starGold
  }

  return ICONS.starGray80
}

const AverageStars = ({ averageRating }) => (
  <React.Fragment>
    <style jsx>{styles}</style>
    <div className="average-stars">
      {STARS_LIST.map((star) => (
        <div key={star}>
          <Icon
            src={getStarIcon(star, averageRating)}
            size={ICON_SIZE.medium}
          />
        </div>
      ))}
    </div>
  </React.Fragment>
)

AverageStars.defaultProps = {
  averageRating: 0,
}

AverageStars.propTypes = {
  averageRating: PropTypes.number,
}

export default withI18next()(AverageStars)
